import Alert from '@mui/material/Alert';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

type ConfirmationDialogContentProps = {
  actionText: string;
  hideProceedText?: boolean;
  name: string;
  objectText: string;
  topAlertMessage?: string;
};

export const ConfirmationDialogContent = ({
  actionText,
  hideProceedText,
  name,
  objectText,
  topAlertMessage,
}: ConfirmationDialogContentProps) => {
  const { t } = useTranslation();

  return (
    <DialogContent dividers>
      {topAlertMessage && (
        <Alert severity="warning" sx={{ mb: 2 }} data-test="delete-warning">
          {topAlertMessage}
        </Alert>
      )}

      <Typography data-test="delete-info">
        {t('You’re about to {actionText} the following {objectText}:', { actionText, objectText })}
      </Typography>
      <Typography variant="body1Bold" sx={{ mb: 3 }} data-test="object-name-to-delete">
        {name}
      </Typography>
      {!hideProceedText && <Typography>{t('Do you want to proceed?')}</Typography>}
    </DialogContent>
  );
};
